export default class StringUtil {

    static capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    titleCase(string) {
        const result = string.replace(/([A-Z])/g, " $1");
        return result.charAt(0).toUpperCase() + result.slice(1);
    }
}